import s from './ErrorBlock.module.scss';

export function ArrowLink() {
  return (
    <svg
      className={s.linkArrow}
      data-qa="arrow image"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5.11239 15.1644L3.8855 13.9375L12.2084 5.61457H4.93531V3.88541H15.1645V14.1146H13.4353V6.84149L5.11239 15.1644Z"
        fill="#26D07C"
      />
    </svg>
  );
}
